import { c as _c } from "react/compiler-runtime";
import Skeleton from "./Skeleton";
interface ISkeletonLoaderProps {
  className?: string;
}
const SkeletonLoader = t0 => {
  const $ = _c(12);
  const {
    className
  } = t0;
  const t1 = `h-full space-y-2 ${className ?? ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-4 w-24" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-2"><Skeleton className="h-8 w-8 rounded-full" /><Skeleton className="h-4 w-32" /></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="space-y-2"><Skeleton className="h-3 w-full" /><Skeleton className="h-3 w-5/6" /></div>;
    t5 = <Skeleton className="h-5 w-3/4" />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="w-full space-y-4 md:w-1/4">{t2}{t3}{t4}{t5}<div className="space-y-2"><Skeleton className="h-3 w-full" /><Skeleton className="h-3 w-4/5" /></div></div>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Skeleton className="h-5 w-full" />;
    t8 = <Skeleton className="h-5 w-4/5" />;
    $[5] = t7;
    $[6] = t8;
  } else {
    t7 = $[5];
    t8 = $[6];
  }
  let t10;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex gap-2"><Skeleton className="h-4 w-12" /><Skeleton className="h-4 w-12" /></div>;
    t10 = <Skeleton className="h-48 w-full rounded-lg md:h-64" />;
    $[7] = t10;
    $[8] = t9;
  } else {
    t10 = $[7];
    t9 = $[8];
  }
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex flex-col gap-6 md:flex-row">{t6}<div className="w-full space-y-4 md:w-3/4">{t7}{t8}{t9}{t10}<div className="flex gap-4"><Skeleton className="h-3 w-24" /><Skeleton className="h-3 w-24" /></div><Skeleton className="h-3 w-32" /></div></div>;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== t1) {
    t12 = <div className={t1}>{t11}</div>;
    $[10] = t1;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  return t12;
};
export default SkeletonLoader;